/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { API_SERVER_URL } from "@/lib/static";
import { getToken, removeToken } from "@/lib/token";
import axios, { AxiosRequestConfig } from "axios";
import { jwtDecode } from "jwt-decode";

export async function apiServices<T>(
  endpoint: string,
  method: "get" | "post" | "put" | "delete" | "patch",
  data?: T,
  config: AxiosRequestConfig = {},
  forceToken?: string | undefined,
): Promise<{
  data: any | null;
  statusCode: number | null;
  message: string | null;
  error: any | null;
}> {
  try {
    const BASE_URL = API_SERVER_URL;
    // const URL = `${BASE_URL}${endpoint}`;
    const isAbsoluteURL = /^(http|https):\/\//i.test(endpoint);
    const URL = isAbsoluteURL ? endpoint : `${BASE_URL}${endpoint}`;

    const token = forceToken || getToken();
    if (token) {
      try {
        const decoded = jwtDecode<{ exp?: number }>(token);
        if (decoded.exp && decoded.exp * 1000 < Date.now()) {
          removeToken();
          window.location.href = "/login";
          return {
            data: null,
            statusCode: 401,
            message: "Session expired. Please log in again.",
            error: "Token expired",
          };
        }
      } catch (_error: any) {
        removeToken();
        window.location.href = "/login";
        return {
          data: null,
          statusCode: 401,
          message: "Invalid session. Please log in again.",
          error: "Invalid token",
        };
      }
    }

    const headers = token
      ? { Authorization: `Bearer ${token}`, ...config.headers }
      : config.headers;

    // For file uploads, ensure Content-Type is set
    const finalHeaders =
      data instanceof FormData
        ? { ...headers, "Content-Type": "multipart/form-data" }
        : headers;

    const response = await axios({
      url: URL,
      method,
      data: method !== "get" && method !== "delete" ? data : undefined,
      headers: finalHeaders,
      ...config,
    });

    return {
      data: response.data,
      statusCode: response.status,
      message: response.statusText,
      error: null,
    };
  } catch (error: any) {
    return {
      data: null,
      statusCode: error.response?.status || null,
      message:
        error.response?.data?.status?.msg ||
        error.response?.statusText ||
        error.message,
      error: error.response?.data || error.message,
    };
  }
}
